import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import Loading from "../common/Loading";
import NoContent from "../common/NoContent";
import PageTitle from "../common/PageTitle";
import TabHeader from "../common/TabHeader";
import { useAppContext } from "../../providers/ProviderAppContainer";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";

export default function WebsiteFacilitiesPage() {
    const { requestAPI, showToast } = useAppContext();
    const [loading, setLoading] = useState();
    const [saving, setSaving] = useState();
    const [error, setError] = useState();
    const [record, setRecord] = useState();

    useEffect(() => {
        requestAPI({
            requestPath: "website/facilities-page",
            requestMethod: "GET",
            setLoading,
            onRequestStart: setError,
            onRequestFailure: setError,
            onResponseReceieved: (data, responseCode) => {
                if (data && responseCode === 200) setRecord(data);
                else setError("Couldn't load Facilities Page");
            },
        });
    }, [requestAPI]);

    const saveRecord = () => {
        requestAPI({
            requestPath: "website/facilities-page",
            requestMethod: "PATCH",
            requestPostBody: record,
            setLoading: setSaving,
            onRequestFailure: () => showToast({ severity: "error", summary: "Failed", detail: "Failed To Update Facilities Page !", life: 2000 }),
            onResponseReceieved: (updated, responseCode) => {
                if (updated && responseCode === 200) {
                    setRecord(updated);
                    showToast({ severity: "success", summary: "Updated", detail: "Facilities Page Updated", life: 1000 });
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: updated?.error || "Failed To Update Facilities Page !", life: 2000 });
                }
            },
        });
    };

    return (
        <div className="flex flex-column h-full">
            <PageTitle title="Facilities Page" />
            <TabHeader
                className="px-3 pt-3"
                title="Facilities Page"
                highlights={["Save writes this page to the database"]}
            />
            <Divider />
            {loading ? <Loading /> : null}
            {error ? <NoContent error={error} /> : null}
            {!loading && !error && record ? (
                <div className="flex-1 overflow-y-scroll p-3 flex flex-column">
                    <FloatLabel className="mt-5">
                        <InputText id="eyebrow" className="w-full" value={record?.eyebrow ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, eyebrow: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="eyebrow">Eyebrow</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="title" className="w-full" value={record?.title ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, title: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="title">Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="description" className="w-full" rows={4} autoResize value={record?.description || ""} onChange={(event) => setRecord((prev) => ({ ...prev, description: event.target.value }))} disabled={saving} />
                        <label htmlFor="description">Description</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="intro_eyebrow" className="w-full" value={record?.intro_eyebrow ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, intro_eyebrow: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="intro_eyebrow">Intro Eyebrow</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="intro_title" className="w-full" value={record?.intro_title ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, intro_title: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="intro_title">Intro Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="intro_text" className="w-full" rows={4} autoResize value={record?.intro_text || ""} onChange={(event) => setRecord((prev) => ({ ...prev, intro_text: event.target.value }))} disabled={saving} />
                        <label htmlFor="intro_text">Intro Text</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="carousel_eyebrow" className="w-full" value={record?.carousel_eyebrow ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, carousel_eyebrow: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="carousel_eyebrow">Carousel Eyebrow</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="carousel_title" className="w-full" value={record?.carousel_title ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, carousel_title: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="carousel_title">Carousel Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="carousel_description" className="w-full" rows={4} autoResize value={record?.carousel_description || ""} onChange={(event) => setRecord((prev) => ({ ...prev, carousel_description: event.target.value }))} disabled={saving} />
                        <label htmlFor="carousel_description">Carousel Description</label>
                    </FloatLabel>
                    <div className="flex align-items-center gap-2 mt-4">
                        <Checkbox inputId="show_filters" checked={!!record?.show_filters} onChange={(event) => setRecord((prev) => ({ ...prev, show_filters: event.checked }))} disabled={saving} />
                        <label htmlFor="show_filters" className={TEXT_SMALL}>Show Filters</label>
                    </div>
                    <FloatLabel className="mt-5">
                        <InputText id="ecosystem_title" className="w-full" value={record?.ecosystem_title ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, ecosystem_title: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="ecosystem_title">Ecosystem Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="ecosystem_description" className="w-full" rows={4} autoResize value={record?.ecosystem_description || ""} onChange={(event) => setRecord((prev) => ({ ...prev, ecosystem_description: event.target.value }))} disabled={saving} />
                        <label htmlFor="ecosystem_description">Ecosystem Description</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="closing_brand" className="w-full" value={record?.closing_brand ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, closing_brand: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="closing_brand">Closing Brand</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="cta_title" className="w-full" value={record?.cta_title ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, cta_title: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="cta_title">Cta Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="cta_primary_text" className="w-full" rows={4} autoResize value={record?.cta_primary_text || ""} onChange={(event) => setRecord((prev) => ({ ...prev, cta_primary_text: event.target.value }))} disabled={saving} />
                        <label htmlFor="cta_primary_text">Cta Primary Text</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="cta_primary_url" className="w-full" value={record?.cta_primary_url ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, cta_primary_url: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="cta_primary_url">Cta Primary Url</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputText id="cta_secondary_url" className="w-full" value={record?.cta_secondary_url ?? ""} onChange={(event) => setRecord((prev) => ({ ...prev, cta_secondary_url: event.target.value }))} disabled={saving} pt={{ root: { className: TEXT_NORMAL } }} />
                        <label htmlFor="cta_secondary_url">Cta Secondary Url</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="float_title" className="w-full" rows={4} autoResize value={record?.float_title || ""} onChange={(event) => setRecord((prev) => ({ ...prev, float_title: event.target.value }))} disabled={saving} />
                        <label htmlFor="float_title">Float Title</label>
                    </FloatLabel>
                    <FloatLabel className="mt-5">
                        <InputTextarea id="line_title" className="w-full" rows={4} autoResize value={record?.line_title || ""} onChange={(event) => setRecord((prev) => ({ ...prev, line_title: event.target.value }))} disabled={saving} />
                        <label htmlFor="line_title">Line Title</label>
                    </FloatLabel>
                    <Button className="mt-5 align-self-start" label="Save" icon="pi pi-check" loading={saving} onClick={saveRecord} />
                </div>
            ) : null}
        </div>
    );
}
